const sessionVuexModule = {
  state: {
    loggedUser: undefined
  },

  mutations: {
    setLoggedUser: (state, user) => (state.loggedUser = user)
  },

  getters: {
    loggedUser: state => state.loggedUser,
    isAdmin: state => !!(state.loggedUser && state.loggedUser.role === "admin"),
  }
};

export default sessionVuexModule;
